import { render, staticRenderFns } from "./CollegeAllHodTestReports.vue?vue&type=template&id=ede496f2"
import script from "./CollegeAllHodTestReports.vue?vue&type=script&lang=js"
export * from "./CollegeAllHodTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports